(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('TestController', TestController);

    TestController.$inject = ['$scope', '$state', 'Test'];

    function TestController($scope, $state, Test) {
        var vm = this;

        vm.tests = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Test.query(function (result) {
                vm.tests = result;
            });
        }

        function search() {
            vm.loadAll();
        }
    }
})();
